module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei7.svg";